import { LOCAL_STORAGE_KEYS } from 'constant/localStorage';
import { LocalStorageParams } from '../types/api';
import { useQRStore } from '../store/useQRStore';

export const useQRFlow = () => {
  const { dataFromURL } = useQRStore();

  const setItemsToLocalStorage = ({
    access,
    refresh,
    user_detail,
  }: LocalStorageParams) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, access);
    localStorage.setItem(LOCAL_STORAGE_KEYS.REFRESH, refresh);
    localStorage.setItem(LOCAL_STORAGE_KEYS.USER_ID, user_detail.id);
    if (dataFromURL?.tenantID) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.TENANT, dataFromURL?.tenantID);
    }
  };

  const clearLocalStorage = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TENANT);
  };

  return { setItemsToLocalStorage, clearLocalStorage };
};
